import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

import { useState } from "react";
import { Card, Grid } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";

import { useCustomerValue } from "providers/CustomerContext";
import { getPickslipNumberOption, getPickslipReport } from "services/data.report.service";
import { InboundLayout } from "ui-components/Layout";
import { LoadingDialog } from "ui-components/Alert";
import { SelectFields } from "ui-components/Form";
import { downloadPDF2, downloadFile } from "layouts/views/common/file";
import { Error_ } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import { Texts } from "ui-components/Form";

function PickslipReport() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const exportPermission = allowAll ||
    (Boolean(permissions["Pickslip Report_Report"]) &&
      permissions["Pickslip Report_Report"].findIndex((b) => b === "export") !== -1);

  const downloadReportMutation = useMutation(getPickslipReport, {
    onSuccess: (response) => {
      if (reportType === "PDF") {
        downloadPDF2(response.data,`${pickslipNumber}.pdf`);
      } else {
        downloadFile(response.data, `${pickslipNumber}.csv`);
      }
    },
    onError: async (data) => {
      let content = await data.response.data.text();
      if (content.includes("No data")) {
        content = "No data";
      }
      setAlert(<Error_ content={content} onChange={setAlert} />);
    },
  });

  const [pickslipNumber, setPickslipNumber] = useState(null);
  const [reportType, setReportType] = useState("PDF");

  const handleSubmit = () => {
    setAlert(null);
    downloadReportMutation.mutate({
      customerCode,
      pickslipNumber,
      reportType,
      reportName: "Pickslip",
    });
  };

  const downloadStatus = downloadReportMutation.status === "loading";

  return (
    <InboundLayout>
      {downloadStatus && <LoadingDialog />}

      <Card sx={{ height: "100%" }}>
        <MDBox p={3}>
          {alert}
          <MDBox pb={3}>
            <MDTypography color="info" variant="h3">
              Export Pickslip Report
            </MDTypography>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Texts
                field={{
                  name: "pickslipNumber",
                  label: "Pickslip Number / Cust Order Number",
                  maxLength: 20,
                }}
                onChange={({ target }) => setPickslipNumber(target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectFields
                field={{
                  name: "reportType",
                  label: "Export to File Type *",
                  value: reportType,
                  errors: {},
                  required: true,
                }}
                options={["PDF", "CSV"]}
                onChange={(e, v) => setReportType(v)}
              />
            </Grid>
          </Grid>

          <MDBox mt={2} display="flex" justifyContent="center">
            <MDButton
              type="submit"
              variant="gradient"
              color="info"
              disabled={!Boolean(pickslipNumber) || !exportPermission}
              onClick={handleSubmit}
            >
              Download
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </InboundLayout>
  );
}

export default PickslipReport;
